<app-entity-editor
  *ngIf="selectedEntity && initialized"
  class="cf-fill"
  [entity]="projectEntity && selectedEntity"
  [groupFilter]="groupFilter"
  (propertyChange)="propertyChanged($event)"
>
</app-entity-editor>
